import Vue from 'vue'
import _ from 'lodash'
import state from './state'

const t = true, f = false;
var log = (title, value, err) => {
  if (!state.debug) return
  console.groupCollapsed('%c' + title + ': ' + (value.type ? value.type : '') + ': ' + (value.id ? value.id : '') + '\n' + new Date(Date.now()), 'color: gray; font-weight: 100; font-size: 10px;')
  console.log('%c ' + JSON.stringify(value, null, 2), 'color:' + (err ? 'red' : 'blue') + ';\n')
  console.groupEnd('%c' + title + ': ' + value.type + '\n' + new Date(Date.now()), 'color: gray; font-weight: 100; font-size: 10px;')
}

const mut = {
  closeAll(state, { only, except }) {
    const views = {
      admin: f,
      app: t,
      auth: f,
      cart: f,
      commentEdit: {},
      connectivity: f,
      create: f,
      createtype: f,
      events: f,
      eventsFull: f,
      feedback: {},
      frame: mut.show.frame,
      items: f,
      jobs: f,
      jobsFull: f,
      manageItem: {},
      menus: {},
      messages: f,
      newMessage: f,
      notification: {},
      notifications: f,
      xmbl: f,
      pages: f,
      profile: f,
      reputations: {},
      response: {},
      reveal: f,
      secretBox: f,
      share: {},
      terminal: f,
      tokens: {},
      userOptions: f
    }
    let closeviews = Object.keys(views)
    closeviews.map(x =>
      ((except && !except.includes(x)) || (only && only.includes(x)))
        ? mut.set(state, { keys: ['show', x], val: views[x] }) :
        mut.set(state, { keys: ['show'], val: views }))
    // ? store.commit('set', { keys: ['show', x], val: views[x] }) :
    // store.commit('set', { keys: ['show'], val: views }))
  },
  log(logname, payload) {
    !payload && console.log(logname)
    Object.keys(payload.value || payload).forEach((key) => {
      log(key, payload.value ? payload.value[key] : payload[key])
    })
  },
  point(state, payload) {
    payload.time
    var pointerDate = payload.time || Date.now()
    return Vue.set(state.pointer, pointerDate, {
      header: payload.header,
      text: payload.text,
      link: payload.link || f,
      sticky: payload.sticky || f,
      speed: payload.speed || 10000,
      type: payload.type || 'success'
    })
  },
  route(state, payload) {
    if (state.debug) mut.log('route()', payload)
    window.location.href = payload.type === 'app' ? '/admin'
      : payload.type === 'user' ? '/profile/' + payload.id
        : '/i/' + payload.type + '/' + payload.id
    return { type: payload.type, id: payload.id }
  },
  setState(state, payload) {
    if (state.debug) mut.log('setState()', payload)
    if (payload.items) {
      Vue.set(state.items[payload.prop], payload.prop2, payload.val)
    } else if (!payload.items && payload.prop2) {
      state[payload.prop] = state[payload.prop] || {}
      Vue.set(state[payload.prop], payload.prop2, payload.val)
    } else {
      Vue.set(state, payload.prop, payload.val)
    }
    // window.localStorage.setItem(payload.prop, JSON.stringify(state[payload.prop]))
    state.counter++
    return payload
  },
  setMeta(state) {
    state.app.basics.meta && state.app.basics.meta.map(s => {
      var meta = document.createElement(s.element || 'script')
      Object.entries(s).map(a => a[0] !== 'element' && meta.setAttribute(a[0], a[1]))
      document.querySelector('head').append(meta)
      return meta
    })

  },
  setStyle(state) {
    function changeFavicon() {
      document.head || (document.head = document.getElementsByTagName('head')[0])
      var link = document.createElement('link')
      // var faicons = document.createElement('link')
      var oldLink = document.getElementById('dynamic-favicon')
      link.id = 'dynamic-favicon'
      // faicons.id = 'faicons'
      link.rel = 'icon'
      // faicons.rel = 'stylesheet'
      link.href = state.app.logo || '/img/favicon.ico'
      // faicons.href = window.location.origin + '/fa.css'
      if (oldLink) {
        document.head.removeChild(oldLink)
      }
      document.head.appendChild(link)
      var myDynamicManifest = {
        'name': state.app.basics['app name'] || window.location.hostname || 'xmbl',
        'display': 'fullscreen',
        'short_name': state.app.basics['app name'] || window.location.hostname || 'xmbl',
        'description': state.app.mission || 'Enable and empower a new generation of market makers',
        'start_url': window.location.origin || state.app.database || 'https://xmbl',
        'background_color': state.app.style.container || '#f2f2f0',
        'theme_color': state.app.style.color || '#191900',
        'icons': [{
          'src': state.app.logo || window.location.origin + '/img/stock/logo.png',
          'sizes': '32x32',
          'type': 'image/png'
        }]
      }
      const stringManifest = JSON.stringify(myDynamicManifest)
      const blob = new Blob([stringManifest], { type: 'application/json' })
      const manifestURL = URL.createObjectURL(blob)
      Array(...document.getElementsByClassName('xmbl_super_manifest')).map(x => document.head.removeChild(x))
      let manifest = document.createElement('LINK')
      manifest.setAttribute('href', manifestURL)
      manifest.setAttribute('class', 'xmbl_super_manifest')
      manifest.setAttribute('rel', 'manifest')
      document.querySelector('head').append(manifest)
    }
    function updateStyleSheet() {
      var blob = new Blob([
        `html {background: ${state.app.style['background-color'] || 'none'}; } 
          body {height: 100%;  background-size: cover!important; object-fit: cover; color: ${state.app.style.color}; background: url(${state.app.style['background-image']}) fixed center no-repeat; background-size: cover!important;} `,
        `.nav-counts {background-color: ${state.app.style.success}!important} `,
        `a {color: ${state.app.style.color}; opacity: .9;} `,
        `.container {background: ${state.app.style.container}; box-shadow: 0 0 1px ${state.app.style.color}; color: ${state.app.style.color};} `,
        `.sub-container {background: ${state.app.style['sub-container']}; box-shadow: 0 0 4px ${state.app.style.color}; color: ${state.app.style.color};} `,
        `button {background: ${state.app.style.button};} `,
        `.gui-container {background: ${state.app.style.navbar}; box-shadow: 0 0 8px ${state.app.style.color}; color: ${state.app.style.color};} `,
        `input, textarea: {color: ${state.app.style.color}; background: ${state.app.style.navbar}; opacity: .9;} `,
        `.success, .create {background: ${state.app.style.success}} .success-text, .create-text {color: ${state.app.style.success}} .success-border, .create-border {border: 1px solid ${state.app.style.success}!important} `,
        `.warn {background: ${state.app.style.warn}} .warn-text {color: ${state.app.style.warn}} .warn-border {border: 1px solid ${state.app.style.warn}!important} .indicate {background: ${state.app.style.indicate}} .indicate-text {color: ${state.app.style.indicate}} .indicate-border {border: 1px solid ${state.app.style.indicate}!important} .update {background: ${state.app.style.update}} .update-text {color: ${state.app.style.update}} .update-border {border: 1px solid ${state.app.style.update}!important} `,
        `.gm-style div.gm-style-iw-t::after, .gm-style div.gm-style-iw-t::before, .gm-style .gm-style-iw-c {background-color: ${state.app.style['sub-container']} !important; background: ${state.app.style['sub-container']} !important;} `,
        `${state.app.style['custom-css']} `,
        `${state.defaultcss}`
      ], { type: 'text/css' })
      Array(...document.getElementsByClassName('super_custom_css')).map(x => document.head.removeChild(x))
      var css = document.createElement('LINK')
      css.setAttribute('href', window.URL.createObjectURL(blob))
      css.setAttribute("class", "super_custom_css");
      css.setAttribute('rel', 'stylesheet')
      css.setAttribute('type', 'text/css')
      document.querySelector('head').append(css)
    }
    if (!state.app || !state.app.style) {
      state.counter++
      setTimeout(() => {
        mut.setStyle(state)
      }, (50 * state.counter))
    } else {
      if (state.debug) mut.log('setStyle()', state.app.style)
      if (state.app.basics.items) {
        state.app.basics.items.forEach((item) => {
          Vue.set(state.icons, item.name, item.icon)
        })
      }
      updateStyleSheet()
      changeFavicon()
    }
  },
  setScript(state) {
    function loadCustomScript() {
      if (state.app.advanced && state.app.advanced['custom-script']) {
        // Remove any existing custom scripts
        Array(...document.getElementsByClassName('super_custom_script')).map(x => document.head.removeChild(x))
        
        // Create and inject the custom script with state and api exposed
        var script = document.createElement('script')
        script.setAttribute('class', 'super_custom_script')
        script.setAttribute('type', 'text/javascript')
        script.textContent = `
          (function() {
            try {
              // Wait for store to be available
              function waitForStore() {
                if (window.$store) {
                  // Expose state and api globally
                  window.$state = window.$store.state;
                  window.$api = window.$store.dispatch;
                  window.$commit = window.$store.commit;
                  window.$getters = window.$store.getters;
                  ${state.app.advanced['custom-script']}
                } else {
                  setTimeout(waitForStore, 100);
                }
              }
              waitForStore();
            } catch (error) {
              console.error('Custom script error:', error);
            }
          })();
        `
        document.head.insertBefore(script, document.head.firstChild)
      }
    }
    
    if (!state.app || !state.app.advanced) {
      state.counter++
      setTimeout(() => {
        mut.setScript(state)
      }, (50 * state.counter))
    } else {
      if (state.debug) mut.log('setScript()', state.app.advanced)
      loadCustomScript()
    }
  },
  set(state, { key, val, keys, merge }) {
    if (key) return Vue.set(state, key, val)
    let nestedstring = ''
    keys.map((k, ki) => {
      if (ki + 1 < keys.length) {
        if (ki > 0) {
          nestedstring = nestedstring + '.' + k
        } else { nestedstring = k }
        !_.get(state, nestedstring) ? _.set(state, nestedstring, {}) : null
      }
      else {
        if (merge) {
          const existing = _.get(state, nestedstring + '.' + k) || {}
          const merged = _.merge(existing, val)
          _.set(state, nestedstring + '.' + k, merged)
        } else {
          _.set(state, nestedstring + '.' + k, val)
        }
      }
    })
    state.counter = state.counter + 1
    return val
  },
  showhide(state, { prop }) {
    return state.show[prop] = !state.show[prop]
  },
  show(state, { parent, key }) {
    state.show[parent + '.' + key] = !state.show[parent + '.' + key]
    localStorage.setItem('show', JSON.stringify(state.show))
    mut.increment(state)
  },
  increment(state) {
    state.counter++
    localStorage.setItem('counter', state.counter)
  },
  norm(state, string) {
    return string.replaceAll(' ', '_')
  },
  // init() {
  //   return types.util.init()
  // }
}

export default mut